export const displayString = (userId, user, fallbackUsername) => {
  if (userId === user?.id) {
    return user.name
  }

  if (user && user.lastname && user.firstname) {
    return `${user.lastname}, ${user.firstname}`
  }

  return fallbackUsername ?? userId
}
